import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';
const getUrl = url => (url?.startsWith('http') ? url : `${API_BASE}${url}`);

// Picks one signature video (preferred) or photo to headline the home page.
// Falls back to a themed placeholder if no media has been uploaded yet.
export default function StoryShowcase() {
  const { t } = useTranslation();
  const [media, setMedia] = useState(null);

  useEffect(() => {
    Promise.all([
      API.get('/videos').then(r => r.data || []).catch(() => []),
      API.get('/gallery').then(r => r.data || []).catch(() => []),
    ]).then(([videos, gallery]) => {
      const video = videos[0];
      if (video) {
        setMedia(video.sourceType === 'upload'
          ? { kind: 'video', url: getUrl(video.url) }
          : { kind: 'youtube', videoId: video.videoId });
        return;
      }
      const image = gallery.find(g => g.type !== 'video');
      if (image) setMedia({ kind: 'image', url: getUrl(image.url) });
    });
  }, []);

  return (
    <section className="section story-showcase-section">
      <div className="container">
        <div className="story-showcase">
          <div className="story-showcase-media">
            {media?.kind === 'video' && <video src={media.url} autoPlay muted loop playsInline />}
            {media?.kind === 'youtube' && (
              <iframe
                src={`https://www.youtube.com/embed/${media.videoId}?autoplay=1&mute=1&loop=1&playlist=${media.videoId}&controls=0`}
                title="Goshala story"
                frameBorder="0"
                allow="autoplay; encrypted-media"
              />
            )}
            {media?.kind === 'image' && <img src={media.url} alt={t('home.storyTitle')} />}
            {!media && <div className="story-showcase-fallback">🐂</div>}
          </div>
          <div className="story-showcase-overlay" />
          <div className="story-showcase-content">
            <div className="story-showcase-badge">{t('home.storyBadge')}</div>
            <h2>{t('home.storyTitle')}</h2>
            <p>{t('home.storyDesc')}</p>
            <Link to="/videos" className="btn btn-primary btn-lg">{t('home.storyCta')}</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
